import {
  FETCH_BUSINESS_SECTORS,
  FETCH_BUSINESS_SECTORS_ERROR,
  FETCH_BUSINESS_CATEGORIES,
} from '../types';
import Products from 'services/products';

export const fetchBusinessSectors = () => async (dispatch) => {
  try {
    const response = await Products.fetchBusinessSectors();
    dispatch({
      type: FETCH_BUSINESS_SECTORS,
      payload: response.data,
    });
    return;
  } catch (error) {
    dispatch({
      type: FETCH_BUSINESS_SECTORS_ERROR,
      error: error?.response?.data?.message || 'Something went wrong',
    });
    return;
  }
};

export const fetchBusinessCategories = (sectorId) => async (dispatch) => {
  try {
    const response = await Products.fetchBusinessCategories(sectorId);
    dispatch({
      type: FETCH_BUSINESS_CATEGORIES,
      payload: response.data,
    });
    return;
  } catch (error) {
    dispatch({
      type: FETCH_BUSINESS_SECTORS_ERROR,
      error: error?.response?.data?.message || 'Something went wrong',
    });
    return;
  }
};
